module.exports = __webpack_public_path__ + "img/GQ.1f78740d.svg";